import { Controller } from '@hotwired/stimulus';
import {getWindowWidth} from "../helpers";

export default class extends Controller {
  connect() {
    this.mobileMenuToggle = this.element.querySelector('#mobileMenuToggle');
    this.html = document.querySelector('html');

    this.mobileMenuToggle.addEventListener('click', ()=>{
      this.element.classList.toggle('mobile-active');
      this.mobileMenuToggle.classList.toggle('active');
      this.html.classList.toggle('overflow-hidden')
    })

    addEventListener('resize', ()=>{
      if (getWindowWidth() >= 768) {
        this.element.classList.remove('mobile-active');
        this.mobileMenuToggle.classList.remove('active');
        this.html.classList.remove('overflow-hidden')
      }
    })
  }
}
